import { lazyInstantiate } from "@wormhole-foundation/sdk-base";
import { payloadDiscriminator } from "./../../vaa/index.js";
import "./automaticTokenBridgeLayout.js";
import "./tokenBridgeLayout.js";
export const ErrNotWrapped = (token) => new Error(`Token ${token} is not a wrapped asset`);
import "../../registry.js";
/**
 * @namespace TokenBridge
 */
export var TokenBridge;
(function (TokenBridge) {
    const _protocol = "TokenBridge";
    const _transferPayloads = ["Transfer", "TransferWithPayload"];
    const _attestPayloads = ["AttestMeta"];
    const _payloads = [..._transferPayloads, ..._attestPayloads];
    TokenBridge.getTransferDiscriminator = lazyInstantiate(() => payloadDiscriminator([_protocol, _transferPayloads]));
})(TokenBridge || (TokenBridge = {}));
export var AutomaticTokenBridge;
(function (AutomaticTokenBridge) {
    const _protocol = "AutomaticTokenBridge";
    const _payloads = ["TransferWithRelay"];
})(AutomaticTokenBridge || (AutomaticTokenBridge = {}));
export function isTokenTransferDetails(thing) {
    return (thing.token !== undefined &&
        thing.amount !== undefined &&
        thing.from !== undefined &&
        thing.to !== undefined);
}
//# sourceMappingURL=tokenBridge.js.map